import { cn } from '@/lib/utils';
import { Card, CardContent } from '@/components/ui/card';

type KpiCardProps = {
  label: string;
  value: string;
  valueClassName?: string;
  hint?: string;
};

export function KpiCard({ label, value, valueClassName, hint }: KpiCardProps) {
  return (
    <Card>
      <CardContent className="p-4">
        <dl className="flex flex-col gap-1">
          <dt className="text-xs text-muted-foreground">{label}</dt>
          <dd className={cn('text-2xl font-semibold', valueClassName)}>{value}</dd>
          {hint && <dd className="text-xs text-muted-foreground">{hint}</dd>}
        </dl>
      </CardContent>
    </Card>
  );
}
